import React from 'react';
import { Maybe, Sale } from '@gql/schema';
import { FlightsSelectOption, IAirportOption, INightsOption } from './Flights.interfaces';

interface IUseFlightStateArgs {
  flightsEnabled: boolean;
  sale: Maybe<Sale>;
  tripTypeParam?: Maybe<string>;
  durationParam?: Maybe<string>;
  airportCodeParam?: Maybe<string>;
  airportNameParam?: Maybe<string>;
}

interface IUseFlightStateResult {
  flightState: IFlightState;
  setFlightState: React.Dispatch<React.SetStateAction<IFlightState>>;
  flightsSelected: boolean;
  setFlightsSelected: (arg: boolean) => void;
}

// TODO - Move to selection state
export interface IFlightState {
  selectedAirport: IAirportOption;
  selectedNights: INightsOption;
}

/**
 * This will be used to store flight related gloabl state
 */
export const useFlightState: (args: IUseFlightStateArgs) => IUseFlightStateResult = ({
  flightsEnabled,
  sale,
  tripTypeParam,
  durationParam,
  airportCodeParam,
  airportNameParam,
}) => {
  /**
   * Populate initial flight state in order of priority
   * - FROM url param values
   * - FROM sale prices withFlights
   */
  const { withFlights } = sale?.prices ?? {};
  const initialDepartureAirportName = airportNameParam ?? withFlights?.departureAirportName ?? '';
  const initialDepartureAirportCode = airportCodeParam ?? withFlights?.departureAirportCode ?? '';
  const initialDuration = durationParam ? Number(durationParam) : null;

  const initialFlightsSelected =
    flightsEnabled && tripTypeParam === FlightsSelectOption.hotelWithFlights;

  // Move remaining state out into selection state
  const [flightsSelected, setFlightsSelected] = React.useState(initialFlightsSelected);
  const [flightState, setFlightState] = React.useState<IFlightState>({
    selectedAirport: {
      code: initialDepartureAirportCode,
      title: initialDepartureAirportName,
    },
    selectedNights: initialDuration,
  });

  return {
    flightState,
    setFlightState,
    flightsSelected,
    setFlightsSelected,
  };
};
